import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { LaboratoryTubesEdit } from "src/app/model/laboratory-tubes/laboratory-tubes-edit";
import { LaboratoryTubesService } from "src/app/services/laboratory-tubes/laboratory-tubes.service";
import {
  ObservationDialogComponent,
  ObservationDialogEditResponse,
} from "../../dialogs/observation-dialog/observation-dialog.component";
import { LaboratoryTubeStatus } from "src/app/model/laboratory-tubes/laboratory-tube-status";
import { SearchFilter } from "src/app/infrastructure/iFilter-component";
import { LaboratoryTubeRejectionReasonFilter } from "src/app/model/laboratory-tubes/laboratory-tube-rejection-reason-filter";
import { ReceivedLabSampleComponent } from "../../dialogs/received-lab-sample/received-lab-sample.component";

@Component({
  selector: "app-laboratory-tubes-wizard",
  templateUrl: "./laboratory-tubes-wizard.component.html",
  styleUrls: ["./laboratory-tubes-wizard.component.css"],
})
export class LaboratoryTubesWizardComponent implements OnInit {
  details: LaboratoryTubesEdit;
  procedures: string;
  tube: string;
  loadingMasiveAction: boolean;
  loading: boolean;
  searchFilters: SearchFilter[];
  rejectionReasons: LaboratoryTubeRejectionReasonFilter[] = [];
  medicalAppointmentProcedureIds: number[] = [];
  @ViewChild("receivedLab", { static: false })
  receivedLab: ReceivedLabSampleComponent;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private laboratoryTubesService: LaboratoryTubesService
  ) {}

  async ngOnInit() {
    this.loading = true;
    const id = this.route.snapshot.params["id"];
    this.rejectionReasons =
      await this.laboratoryTubesService.getRejectionReasons();
    this.details = await this.laboratoryTubesService.getDetails(id);
    this.medicalAppointmentProcedureIds =
      this.details.MedicalAppointmentProcedureIds;
    this.tube = `${this.details.Label} - ${this.details.Abbreviation} - ${this.details.Description}`;
    this.procedures = this.details.PracticeRegions.map(
      (x) => `${x.Name} (${x.Code})`
    ).join(" - ");

    this.loading = false;
  }

  get someChecked() {
    return this.receivedLab && this.receivedLab.someChecked;
  }

  get allChecked() {
    return this.receivedLab && this.receivedLab.allChecked;
  }

  toggleAllReceived(checked: boolean) {
    this.receivedLab.changeAll(checked); // accede al hijo por ViewChild
  }

  async finish() {
      if(this.receivedLab.allChecked) {
        await this.setAcepted();
      } else {
        await this.setRejected();
      }
  }

  async setAcepted() {
    const dialogRef = this.dialog.open(ObservationDialogComponent, {
      width: "50%",
      data: {
        text: "",
        textMenu: "Observaciones",
        noRequired: true,
      },
    });

    dialogRef
      .afterClosed()
      .subscribe(async (response: ObservationDialogEditResponse) => {
        if (response) {
          this.loadingMasiveAction = true;
          await this.receivedLab.update();
          const ids = [this.details.Id];

          await this.laboratoryTubesService.changeStatus(
            ids,
            LaboratoryTubeStatus.Aceptado,
            response.text,
            null,
            !this.receivedLab.allChecked
          );

          history.back();
        }
      });
  }

  async setRejected() {
    const dialogRef = this.dialog.open(ObservationDialogComponent, {
      width: "50%",
      data: {
        text: "",
        textMenu: "Observaciones",
        noRequired: true,
        filterText: "Motivo de rechazo",
        filterItems: this.rejectionReasons,
      },
    });

    dialogRef
      .afterClosed()
      .subscribe(async (response: ObservationDialogEditResponse) => {
        if (response) {
          this.loadingMasiveAction = true;
          const ids = [this.details.Id];
          await this.laboratoryTubesService.changeStatus(
            ids,
            LaboratoryTubeStatus.Rechazado,
            response.text,
            response.selectedFilter ? response.selectedFilter.Id : null
          );
          history.back();
        }
      });
  }

  async revertStatus() {
    const dialogRef = this.dialog.open(ObservationDialogComponent, {
      width: "50%",
      data: {
        text: "",
        textMenu: "Observaciones",
        noRequired: true,
      },
    });

    dialogRef
      .afterClosed()
      .subscribe(async (response: ObservationDialogEditResponse) => {
        if (response) {
          this.loadingMasiveAction = true;
          const ids = [this.details.Id];
          await this.laboratoryTubesService.revertStatus(ids, response.text);
          history.back();
        }
      });
  }

  cancel() {
    history.back();
  }
}
